import { useSession } from "../lib/session";
import { cx } from "../lib/cx";
import { ClayButton } from "./ClayButton";
import { ThemeToggle } from "./ThemeToggle";

export interface TopbarProps {
  title: string;
  subtitle?: string;
  onOpenMenu?: () => void;
}

export function Topbar({ title, subtitle, onOpenMenu }: TopbarProps) {
  const me = useSession();
  const isAdmin = me?.role === "admin";

  return (
    <header className="flex flex-wrap items-center justify-between gap-4 px-1 py-2">
      <div className="flex items-center gap-3">
        {onOpenMenu ? (
          <ClayButton
            variant="secondary"
            size="sm"
            className="lg:hidden"
            onClick={onOpenMenu}
            aria-label="Buka menu navigasi"
            leftIcon={
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" aria-hidden="true">
                <path d="M4 7h16M4 12h16M4 17h16" />
              </svg>
            }
          >
            <span className="sr-only">Menu</span>
          </ClayButton>
        ) : null}
        <div>
          <h1 className="text-xl font-bold leading-tight text-text sm:text-2xl">{title}</h1>
          {subtitle ? <p className="mt-0.5 text-sm text-muted">{subtitle}</p> : null}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <ThemeToggle />
        {me ? (
          <div className="flex items-center gap-3 rounded-card bg-surface px-3 py-2 shadow-clay">
            <span className="flex h-9 w-9 items-center justify-center rounded-full accent-gradient text-sm font-bold text-white">
              {me.name.trim().charAt(0).toUpperCase() || me.email.charAt(0).toUpperCase()}
            </span>
            <div className="hidden text-right sm:block">
              <p className="text-sm font-semibold leading-tight text-text">{me.name}</p>
              <p className="text-xs leading-tight text-muted">{me.email}</p>
            </div>
            <span
              className={cx(
                "rounded-full px-2.5 py-1 text-xs font-bold",
                isAdmin
                  ? "accent-gradient text-white"
                  : "bg-bg text-accent shadow-clay-pressed",
              )}
            >
              {isAdmin ? "Admin" : "Leader"}
            </span>
          </div>
        ) : null}
      </div>
    </header>
  );
}
